import React from 'react';

import IconCheckMarkRounded from '@components/Images/Rebranding/IconCheckMarkRounded';

interface BenefitsProps {
  benefits: string[];
}

const Benefits = ({ benefits }: BenefitsProps) => {
  return (
    <ul className="m-0 mt-24 list-none p-0">
      {benefits.map((benefit, index) => (
        <li
          key={index}
          className="mb-16 flex font-suisse-intl text-body-sm font-light text-black last:mb-0"
        >
          <IconCheckMarkRounded className="mr-8 w-[18px] shrink-0 text-primary-magenta" /> {benefit}
        </li>
      ))}
    </ul>
  );
};

export default Benefits;
